<template>
  <el-col :span="24" :style="{height: height}" style="position: relative; overflow: hidden;
        box-sizing: border-box;">
    <div id="baiduMap" style="height: 100%;width:100%;" />
    <div class="leftMenu" :style="{width:getLeftItemWidth()}">

      <div style="width: 100%;margin-top: 10px;cursor: pointer;" v-for="(item,index) in chartConfig.classify" :style="getSelectStyle(item)">
        <div class="item" @click="changeClassify(item)" :style="{height:getLeftItemHeight(),lineHeight:getLeftItemHeight(),marginLeft:getLeftMargin()}">
          <img :src="item.icon" alt="" :style="{width:getLeftItemImageWidth()}" style="margin-right: 10px;" />
          {{item.name}}
        </div>
      </div>
    </div>
    <template v-for="(item,index) in circleImage">
      <div class="imagePosition" style="z-index: 1;" :style="{left:getLeft(item),top:item.top}">
        <img src="../../assets/arround3.gif" style="z-index: 1;" :style="{width:item.width+'px',height:item.height+'px'}">
      </div>
    </template>
    <template v-for="(item,index) in markerImage">
      <div class="imagePosition" @click="markerClick(item)" v-if="checkMarkerShow(item)" style=" overflow: hidden; box-sizing: border-box;z-index: 10;"
        :style="{left:item.left,top:item.top}">
        <img :src="item.icon" :style="{width:item.width+'px',height:item.height+'px'}" style="cursor: pointer;z-index: 10;">
      </div>
    </template>
    <user-dialog-component ref="userDialog" :currentMarker="currentMarker"></user-dialog-component>
    <video-dialog-component ref="videoDialog" :currentMarker="currentMarker"></video-dialog-component>
    <other-dialog-component ref="otherDialog" :currentMarker="currentMarker"></other-dialog-component>
    <event-dialog-component ref="eventDialog" :eventBtnLocation="chartConfig.btnLocation" :currentMarker="currentMarker"></event-dialog-component>
  </el-col>
</template>

<script>
  import VideoHls from '../images/VideoHls.vue'
  import UserDialogComponent from './components/UserDialogComponent.vue'
  import VideoDialogComponent from './components/VideoDialogComponent.vue'
  import OtherDialogComponent from './components/OtherDialogComponent.vue'
  import EventDialogComponent from './components/EventDialogComponent.vue'
  import {
    getLastYearEventService,
    getMarkerService
  } from '../../api/chart/chart/fwYjzhEvent.js'
  import {
    debounce
  } from '../../utils/helper.js'

  import fwUtil from 'framework-util'
  //import TRTC from 'trtc-js-sdk';
  import lodash from 'lodash'
  let client = null

  export default {
    props: {
      className: {
        type: String,
        default: 'chart'
      },
      width: {
        type: Number,
        default: 24
      },
      height: {
        type: String,
        default: '100%'
      },
      autoResize: {
        type: Boolean,
        default: true
      },
      queryConfig: {
        type: Object,
        default () {
          return {
            url: null,
            params: []
          }
        }
      },
      // 图标配置
      chartConfig: {
        type: Object,
        default: function() {
          return {
            //事件跳转地址
            btnLocation:null
          }
        }
      },
      screen: {
        type: Object,
        default () {
          return {
            height: 1920,
            width: 1280,
          }
        }
      },
      page: {
        type: Object,
        default () {
          return {
            height: 1920,
            width: 1280,
          }
        }
      }
    },
    components: {
      VideoHls,
      UserDialogComponent,
      VideoDialogComponent,
      OtherDialogComponent,
      EventDialogComponent
    },
    computed: {
      widthHeight() {
        return {
          width: this.width,
          height: this.height
        }
      }
    },
    data() {
      return {
        // agentData:'aa',
        websock: null,
        currentShowType: '',
        videoConfig: {
          videoSrc: null
        },
        timer: null,
        sidebarElm: null,
        image2Left: '100px',
        image2Top: '100px',
        chartConfigModel: {},
        currentMarker: {},
        circleImage: [],
        markerImage: [],
        markerData: [],
        eventImage: [],
        circleList: [],
        map: null,
        eventItem: [],
        defaultConfig: {
          distance: 1000,
          canMove: true,
          item: [{
            id: '1',
            name: '23',
            lng: 116.404,
            lat: 39.915,
            width: 35,
            height: 50,
            showType: 'event',
            dialogType: 'event',
            btnLocation:null,
            zIndex: 10,
            title: '',
            icon: 'data:image/png;base64,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',
            content: [{
              label: '位置',
              detail: ''
            }],
            image: '123123',
            arround: [{
              id: '2',
              name: 'sdf',
              lng: 116.404,
              lat: 39.915,
              zIndex: 12,
              width: 35,
              height: 35,
              dialogType: 'user',
              showType: 'user',
              icon: 'data:image/png;base64,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',
              title: '',
              content: [{
                label: '位置',
                detail: ''
              }],
              image: '123123',
            }]
          }],
          zoom: 12
        }

      }
    },
    watch: {
      // 防止表格预置数据不成功，涉及生命周期问题
      chartConfig: {
        handler(newValue, oldValue) {
          this.chartConfigModel = lodash.cloneDeep(newValue)
          let _config = lodash.cloneDeep(this.defaultConfig)
          lodash.merge(_config, this.chartConfigModel)
          this.chartConfigModel = _config
          console.error("====watch  chartConfig")
          this.initBaiduMap()
        },
        deep: true
      },
      queryConfig: {
        handler(newValue, oldValue) {
          this.getLastYearEvent()
        },
        deep: true
      },
      widthHeight: {
        handler(newValue, oldValue) {
          this.initBaiduMap()
          //this.setHotMap()
        },
        deep: true
      }
    },
    // created() {
    // //  this.initWebSocket()
    //  this.global_initWebSocket();
    // },
    mounted() {
      let that = this
      this.$nextTick(() => {
        that.chartConfigModel = lodash.cloneDeep(that.chartConfig)
        let _config = lodash.cloneDeep(that.defaultConfig)
        lodash.merge(_config, that.chartConfigModel)
        that.chartConfigModel = _config
        console.error("====mounted  chartConfig")
        that.initBaiduMap()
        that.getLastYearEvent()


      })

      this.timer = setInterval(function() {
        that.getLastYearEvent()
      }, 1000 * 30)

      // this.setHotMap()
    },
    beforeDestroy() {
      if(this.timer!=null){
        clearInterval(this.timer)
        this.timer=null
      }
     // this.websocketclose();
    },
    methods: {
      // initWebSocket() { //初始化weosocket
      //   const wsuri = this.$commonApi.getWebScoketUrl() +
      //     "/socket/1?ws_token=" + this.$commonApi.getTokenInfo(); //ws地址
      //     console.log("ws地址"+wsuri);
      //   this.websock = new WebSocket(wsuri);
      //   this.websock.onopen = this.websocketonopen;
      //   this.websock.onerror = this.websocketonerror;
      //   this.websock.onmessage = this.websocketonmessage;
      //   this.websock.onclose = this.websocketclose;
      // },
      // websocketonopen() {
      //   console.log("WebSocket连接成功");
      //   this.websocketsend(this.agentData);
      // },
      // websocketonerror(e) { //错误
      //   console.log("WebSocket连接发生错误");
      // },
      // websocketsend(agentData) { //数据发送
      //   this.websock.send(agentData);
      // },
      // websocketclose(e) { //关闭
      //   console.log("connection closed ()");
      // },
      // selectMarker(item) {

      // },
      // websocketonmessage(e) { //数据接收
      //   //注意：长连接我们是后台直接1秒推送一条数据，
      //   //但是点击某个列表时，会发送给后台一个标识，后台根据此标识返回相对应的数据，
      //   //这个时候数据就只能从一个出口出，所以让后台加了一个键，例如键为1时，是每隔1秒推送的数据，为2时是发送标识后再推送的数据，以作区分
      //   // if (e.data == '1') {
                                                          //     // this.getLastYearEvent()
      //   // }
      // console.log("websocket响应数据"+e.data);

      // },
      checkExistEvent(id, name, address) {
        if (this.markerImage) {

          for (let i = 0; i < this.markerImage.length; i++) {
            if (id) {
              if (id == this.markerImage[i].id) {
                return true
              }
            }
            if (name && address) {
              if (name == this.markerImage[i].name && address == this.markerImage[i].address) {
                return true
              }
            }
          }
        }
        return false;
      },
      getLastYearEvent() {
        let that = this
        if (that.chartConfigModel.region) {
          that.getMarker(that.chartConfigModel.region, null, null, 0, that.currentShowType)
        }
        let params = {}
        if (this.queryConfig && this.queryConfig.params) {

          for (let i = 0; i < this.queryConfig.params.length; i++) {
            if (this.queryConfig.params[i].target &&
              this.queryConfig.params[i].source) {
              let _value = fwUtil.Helper.GetQueryString(this.queryConfig.params[i].source)
              if (_value) {
                params[this.queryConfig.params[i].target] = _value
              }
            }
          }
        }
        getLastYearEventService(params).then((res) => {
          that.eventItem = res;
          if (res && res.length > 0) {
            let point = new BMap.Point(res[0].addressLng, res[0].addressLat)
            that.map.panTo(point)
          }
          for (let i = 0; i < res.length; i++) {
            let point = new BMap.Point(res[i].addressLng, res[i].addressLat)
            let circle = new BMap.Circle(point, that.chartConfigModel.distance, {
              fillColor: "",
              strokeColor: "red",
              strokeWeight: 1,
              fillOpacity: 0.001,
              strokeOpacity: 0.1
            });
            if (res[i].state != '3') {
              if (!that.checkExistEvent(res.id)) {
                 that.map.addOverlay(circle);
                that.circleList.push(circle)
                that.circleImage.push(that.setCircle(circle.getCenter(), circle.getBounds().getSouthWest()));
              }
            }

            let point2 = new BMap.Point(res[i].addressLng, res[i].addressLat)
            let markerPosition = that.setMarkerPosition(point2)
            let icon =
              'data:image/png;base64,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'
            if (res[i].state != '3') { //没有出来完成
              icon = that.getIcon('event')
            }
            if (!that.checkExistEvent(res.id)) {
              that.markerImage.push({
                left: markerPosition.left + 'px',
                top: markerPosition.top + 'px',
                lng: res[i].addressLng,
                lat: res[i].addressLat,
                name: res[i].eventName,
                id: res[i].id,
                title: res[i].eventName,
                address: res[i].addressName,
                time: res[i].createTime,
                eventTypeDisplay: res[i].eventTypeDisplay,
                icon: icon,
                content: res[i].content,
                width: 35,
                height: 50,
                image: res[i].image,
                showType: 'event',
                fjList: res[i].fjList,
                zIndex: 10
              });
            }

            if (!that.chartConfigModel.region) {
              that.getMarker("", res[i].addressLng, res[i].addressLat, this.chartConfigModel.distance, that.currentShowType)
            }
          }
        })
      },
      getIcon(type) {
        if (this.chartConfig.classify) {
          for (let i = 0; i < this.chartConfig.classify.length; i++) {
            if (type == this.chartConfig.classify[i].code) {
              return this.chartConfig.classify[i].icon
            }
          }
        }
        return ""
      },

      getMarker(region, centerLng, centerLat, distance, type) {
        let that = this

        if (that.markerData) {
          for(let i=that.markerData.length-1;i>=0;i--){
            if(that.markerData.showType==='user' || that.markerData.showType==='jiankong'){
              that.markerData.splice(i,1);
            }
          }
        }
        getMarkerService({
          type: type,
          region: region,
          lng: centerLng,
          lat: centerLat,
          distance: distance
        }).then((res) => {
          if (res && res.length > 0) {
            for (let i = 0; i < res.length; i++) {
              let findClassify=false;
               if(this.chartConfig.classify && this.chartConfig.classify.length>0){
                 for(let j=0;j<this.chartConfig.classify.length>0;j++){
                   if(res[i].type==this.chartConfig.classify[j].code){
                     findClassify=true
                     break;
                   }
                 }
               }
               if(!findClassify){
                 continue;
               }
              if (!that.checkExistEvent(res[i].id, res[i].name, res[i].address)) {
                 that.markerData.push(res[i])
              }

              let point2 = new BMap.Point(res[i].location.lng, res[i].location.lat)
              let markerPosition = that.setMarkerPosition(point2)
              if (!that.checkExistEvent(res[i].id, res[i].name, res[i].address)) {
                that.markerImage.push({
                  left: markerPosition.left + 'px',
                  top: markerPosition.top + 'px',
                  lng: res[i].location.lng,
                  lat: res[i].location.lat,
                  name: res[i].name,
                  address: res[i].address,
                  telphone: res[i].telphone,
                  icon: that.getIcon(res[i].type),
                  content: '',
                  width: 25,
                  height: 25,
                  url: res[i].url,
                  gh: res[i].gh,
                  image: res[i].image,
                  showType: res[i].type,
                  zIndex: 5
                });
              }
            }
          }
        })
      },
      getSelectStyle(item) {
        if (item.code == this.currentShowType) {
          return "background: rgba(0, 177, 255, 0.3);border: 3px solid #00B1FF;"
        } else {
          return ""
        }
      },
      closeVideo() {

        if (client == null) {
          //this.dialogVideoVisible = false
          return;
        }
        client
          .leave()
          .then(() => {})
          .catch(error => {
            console.error('退房失败 ' + error);
          });
        this.dialogVideoVisible = false
      },
      createMeeting() {
        // this.dialogVideoVisible=true

      },
      markerClick(item) {
        this.currentMarker = item
        if (item.showType === 'jiankong') {
          this.$refs.videoDialog.show()
        } else if (item.showType === 'user') {
          this.$refs.userDialog.show()
        } else if (item.showType === 'event') {
          this.$refs.eventDialog.show()
        } else {
          this.$refs.otherDialog.show()
        }
        return false;
        // if (item.dialogType == 'user') {
        //   this.dialogUserVisible = true
        // }
        //alert(item.name)
      },
      checkMarkerShow(item) {
        if (this.currentShowType == '') {
          return true;
        }
        // if (item.showType != 'event' &&
        //   this.currentShowType != item.showType) {
          if ( this.currentShowType != item.showType) {
          return false;
        }
        return true;
      },
      changeClassify(item) {
        this.currentShowType = item.code

      },
      getLeft(item) {
        return item.left;
      },
      fsdf() {

      },
      createEventCircle(item) {
        if (!item || item.length <= 0) {
          return;
        }

      },
      initBaiduMap() {
        const _that = this

console.error("===========      initBaiduMap() {")
        let that = this
        if (that.map == null) {
          that.map = new BMap.Map('baiduMap') // 创建Map实例
          console.info("map实例")
          console.info(that.map)
          that.map.addEventListener('zoomend', function(e) {
            var ZoomNum = that.map.getZoom()
          })
          if (!this.chartConfigModel.item || this.chartConfigModel.item.length < 0) {
            that.map.centerAndZoom(new BMap.Point(this.chartConfigModel.center.lng, this.chartConfigModel.center.lat),
              this.chartConfigModel
              .zoom) // 创建点坐标,初始化地图,设置中心点坐标和地图级别
          } else {
            that.map.centerAndZoom(new BMap.Point(this.chartConfigModel.item[0].lng, this.chartConfigModel.item[0].lat),
              this.chartConfigModel
              .zoom) // 创建点坐标,初始化地图,设置中心点坐标和地图级别
          }

          _that.hasInitMap = true
        }
        if (this.chartConfigModel.mapStyle) {
          console.info("=============set map styleV2")
          that.map.setMapStyleV2({
            styleJson: this.chartConfigModel.mapStyle
          })
        }
        that.map.enableScrollWheelZoom(); // 允许滚轮缩放

        that.map.addEventListener('moving', function(e) {
          for (let i = 0; i < that.circleList.length; i++) {
            let position = that.setCircle(that.circleList[i].getCenter(), that.circleList[i].getBounds().getSouthWest(),
              that.map)
            that.circleImage[i] = position
            that.$set(that.circleImage, i, position)
          }
          for (let i = 0; i < that.markerImage.length; i++) {
            let point2 = new BMap.Point(that.markerImage[i].lng, that.markerImage[i].lat)
            let _markerImage = that.markerImage[i];
            let positions = that.setMarkerPosition(point2)
            _markerImage.left = positions.left + 'px'
            _markerImage.top = positions.top + 'px'
            that.$set(that.markerImage, i, _markerImage)
          }
          if (that.eventItem && that.eventItem.length > 0) {
            //let point = new BMap.Point(that.eventItem[0].addressLng, that.eventItem[0].addressLat)
            //that.map.panTo(point)
          }

        });
        that.map.addEventListener('zoomend', function(e) {

          for (let i = 0; i < that.circleList.length; i++) {
            let position = that.setCircle(that.circleList[i].getCenter(), that.circleList[i].getBounds().getSouthWest())
            that.$set(that.circleImage, i, position)
          }
          console.error("===getZoom()" + that.map.getZoom())
          for (let i = 0; i < that.markerImage.length; i++) {
            let point2 = new BMap.Point(that.markerImage[i].lng, that.markerImage[i].lat)
            let _markerImage = that.markerImage[i];
            let positions = that.setMarkerPosition(point2)
            _markerImage.left = positions.left + 'px'
            _markerImage.top = positions.top + 'px'
            that.$set(that.markerImage, i, _markerImage)
          }
        })
        that.map.addEventListener('click', function(e) {
          alert('点击位置经纬度：' + e.latlng.lng + ',' + e.latlng.lat);
        });

        // var circle2=null
        // for (let i = 0; i < this.chartConfigModel.item.length; i++) {
        //   var point = new BMap.Point(this.chartConfigModel.item[i].lng, this.chartConfigModel.item[i].lat)
        //   var circle = new BMap.Circle(point, this.chartConfigModel.distance, {
        //     fillColor: "",
        //     strokeColor:"red",
        //     strokeWeight: 1,
        //     fillOpacity: 0.001,
        //     strokeOpacity: 0.1
        //   });
        //   circle2=circle
        //   circleList.push(circle)
        //   that.map.addOverlay(circle);
        //   let markerPosition=this.setMarkerPosition(circle.getCenter());
        //   this.markerImage.push({
        //     left:markerPosition.left+'px',
        //     top:markerPosition.top+'px',
        //     lng: this.chartConfigModel.item[i].lng,
        //     lat: this.chartConfigModel.item[i].lat,
        //     name:this.chartConfigModel.item[i].name,
        //     title: this.chartConfigModel.item[i].title,
        //     icon: this.chartConfigModel.item[i].icon,
        //     content: this.chartConfigModel.item[i].content,
        //     width:this.chartConfigModel.item[i].width,
        //     height:this.chartConfigModel.item[i].height,
        //     image: this.chartConfigModel.item[i].image,
        //     zIndex:this.chartConfigModel.item[i].zIndex,
        //     showType:this.chartConfigModel.item[i].showType,
        //     dialogType:this.chartConfigModel.item[i].dialogType
        //   })
        //   this.circleImage.push(this.setCircle(circle.getCenter(), circle.getBounds().getSouthWest(),that.map));
        //   if(this.chartConfigModel.item[i].arround){
        //     let arrouds=this.chartConfigModel.item[i].arround;
        //     for(let j=0;j<arrouds.length;j++){
        //       let point2=new BMap.Point(arrouds[j].lng, arrouds[j].lat)
        //       let markerPosition2=this.setMarkerPosition(point2);
        //       this.markerImage.push({
        //         left:markerPosition2.left+'px',
        //         top:markerPosition2.top+'px',
        //         lng: arrouds[j].lng,
        //         lat: arrouds[j].lat,
        //         name:arrouds[j].name,
        //         title: arrouds[j].title,
        //         icon: arrouds[j].icon,
        //         content: arrouds[j].content,
        //         width:arrouds[j].width,
        //         height:arrouds[j].height,
        //         image: arrouds[j].image,
        //         zIndex:arrouds[j].zIndex,
        //         showType:arrouds[j].showType,
        //         dialogType:arrouds[j].dialogType
        //       })
        //     }
        //   }
        // }

      },
      setMarkerPosition(center) {
        let pox = this.map.pointToPixel(center);
        return {
          left: pox.x - 25,
          top: pox.y - 25
        }
      },
      setCircle(center, sw) {
        let pox = this.map.pointToPixel(center);
        // this.image2Left=(pox.x-25)+"px"
        // this.image2Top=(pox.y-25)+"px"
        let pox1 = this.map.pointToPixel(sw);
        let dx = Math.abs(pox1.x - pox.x);
        let dy = Math.abs(pox1.y - pox.y);
        var dis = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
        console.info("left==" + (pox.x - dis) + "===width=" + dis * 2)
        return {
          width: dis * 2,
          height: dis * 2,
          left: (pox.x - dis) + "px",
          top: (pox.y - dis) + "px"
        }
      },
      getLeftItemImageWidth() {
        let _height = this.chartConfig.leftItemHeight ? this.chartConfig.leftItemHeight : 40;
        let height = _height / this.page.height * this.screen.height
        return height / 2 + 'px'
      },
      getLeftMargin() {
        let _height = this.chartConfig.leftItemWidth ? this.chartConfig.leftItemWidth : 200;
        let height = _height / this.page.width * this.screen.width
        return height * 0.2 + 'px'
      },
      getLeftItemHeight() {
        let _height = this.chartConfig.leftItemHeight ? this.chartConfig.leftItemHeight : 40;
        let height = _height / this.page.height * this.screen.height
        return height + 'px'
      },
      getLeftItemWidth() {
        let _height = this.chartConfig.leftItemWidth ? this.chartConfig.leftItemWidth : 200;
        let height = _height / this.page.width * this.screen.width
        return height + 'px'
      }


    }
  }
</script>
<style>
  @media screen and (max-width: 2000px) {
    .customDialogClass {
      width: 400px;
    }

    .customDialogClass .title {
      font-size: 20px;
    }

    .customDialogClass .el-dialog__body {
      color: #FFFFFF;
      padding: 0 10px 10px 10px;
    }

    .customDialogBodyClass {
      font-size: 18px;
    }

    .customDialogBodyClass .item {
      margin-top: 5px;
    }
  }

  @media screen and (max-width: 3000px) and (min-width: 2001px) {
    .customDialogClass {
      width: 600px;
    }

    .customDialogClass .title {
      font-size: 25px;
    }

    .customDialogClass .el-dialog__body {
      color: #FFFFFF;
      padding: 0 20px 20px 20px;
    }

    .customDialogBodyClass {
      font-size: 21px;
    }

    .customDialogBodyClass .item {
      margin-top: 10px;
    }
  }

  @media screen and (max-width: 4000px) and (min-width: 3001px) {
    .customDialogClass {
      width: 800px;
    }

    .customDialogClass .title {
      font-size: 30px;
    }

    .customDialogClass .el-dialog__body {
      color: #FFFFFF;
      padding: 0 30px 30px 30px;
    }

    .customDialogBodyClass {
      font-size: 24px;
    }

    .customDialogBodyClass .item {
      margin-top: 15px;
    }
  }

  @media screen and (max-width: 5000px) and (min-width: 4001px) {
    .customDialogClass {
      width: 1000px;
    }

    .customDialogClass .title {
      font-size: 35px;
    }

    .customDialogClass .el-dialog__body {
      color: #FFFFFF;
      padding: 0 40px 40px 40px;
    }

    .customDialogBodyClass {
      font-size: 27px;
    }

    .customDialogBodyClass .item {
      margin-top: 20px;
    }
  }

  .BMap_cpyCtrl {
    display: none;
  }

  .anchorBL {
    display: none;
  }
</style>
<style scoped="scoped">
  .imagePosition {
    position: absolute;
  }



  .leftMenu {
    background: url("data:image/png;base64,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");
    background-repeat: no-repeat;
    background-size: 100%100%;
    -webkit-background-size: 100%100%;
    -o-background-size: 100%100%;
    position: absolute;
    top: 40px;
    left: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .leftMenu .item {
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: left;
    width: 60%;
  }
</style>



// WEBPACK FOOTER //
// src/components/map/CustomMapChart.vue